angular.module('impactx.productview').controller('ProductCodeDummyViewCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'TranslationService',
    'BackService',
    'ToastService',
    'ToolbarService',
    ProductCodeDummyViewCtrl
]);

function ProductCodeDummyViewCtrl($scope, dataGen, $routeParams, TranslationService, BackService, ToastService, ToolbarService) {
    var self = this;

    dataGen.getData($scope, {id: $routeParams.id}, "/productcoding/dummy/view").then(function() {
        $scope.trns.save = TranslationService.get('save');
        $scope.trns.delete = TranslationService.get('delete');

        defineButtons();
    });

    self.save = function() {
        return dataGen.postAsForm($scope, {data: $scope.data}, "/productcoding/dummy/save").then(function() {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            BackService.back();
        });
    };

    self.delete = function() {
        return dataGen.postAsForm({}, {id: $routeParams.id}, "/productcoding/dummy/delete").then(function(data) {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            BackService.back();
        });
    };

    self.checkSelectedCTT = function(newCompanySelected) {
        if (impactX.isDefined($scope, 'data.company.selected.id')) {
            if (!newCompanySelected || newCompanySelected.id !== $scope.data.company.selected.id) {
                $scope.data.defaultCTT.selected = {};
            }
        }

    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: self.delete,
                type: 'dialogaction',
                condition: isEditable
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return $routeParams.id > 0 && $scope.data.canDelete;
    }
}